<template>
  <div class="home">
    <div v-if="!loading">
      <template v-if="isLine">
        <component :is="view"></component>
      </template>
      <template v-else>
        <NotFoundView></NotFoundView>
      </template>
    </div>
  </div>
</template>

<script>
import Ecommerce from '@/views/Ecommerce'
import Transfer from '@/views/Transfer/main'
import Creditcard from '@/views/CreditCard'
import Creditgbprime from '@/views/Payment/CreditGBPrime.vue'
import Nvbbdrink from '@/views/NvbbDrink'
import NotFoundView from '@/components/error/404.vue'
export default {
  name: 'home',
  components: {
    Ecommerce,
    Transfer,
    Creditcard,
    Nvbbdrink,
    NotFoundView,
    Creditgbprime
  },
  data() {
    return {
      loading: true,

      text: '',
      isLine: false
    }
  },
  computed: {
    view() {
      return this.$store.state.view
    }
  },
  mounted: async function () {
    if (this.$route.query['liff.state']) {
      //
    } else if (this.$route.query.view) {
      this.$store.state.view = [
        'ecommerce',
        'transfer',
        'creditcard',
        'nvbbdrink',
        'creditgbprime'
      ].includes(this.$route.query.view)
        ? this.$route.query.view
        : ''
      this.isLine = true
      this.loading = false
    } else {
      this.isLine = false
      this.loading = false
      // window.location.href = "https://www.zwiz.ai/th/sme";
      // document.title = "ZWIZ.AI - ระบบเอไอแชทบอท และ ซีเอ็มเอส สำหรับธุรกิจ";
    }
  }
}
</script>
